"use strict";
import _ from 'lodash';

export default class ChampResultEditController
{
	/*@ngInject*/
	constructor($scope, $filter, $state, $location, $stateParams, $log, $http, Modal)
	{
		if (_.isNil($stateParams.categoryId) || _.isNil($stateParams.raceId)) 
			return $state.go("home");

		this.$http = $http;
		this.$scope = $scope;
		this.$state = $state;
		this.Modal = Modal;
		this.categoryId = $stateParams.categoryId;
		this.raceId = $stateParams.raceId;

		$http.post("/api/backend/champs/champracedata/" + this.categoryId + "/" + this.raceId)
		.then(response =>
		{
			//for (var attrname in response.data)
			//{
				//$scope.data[attrname] = data[attrname];
			//}
			
			this.c = response.data;
		});
	}

	LoadResults()
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/backend/champs/loadraceresults/" + this.categoryId + "/" + this.raceId)
			.then(response => {
				this.$state.go("champresultedit", { categoryId: this.categoryId, raceId: this.raceId}, { reload: true });
			});
		})({
			html: [
				"¿Seguro que deseas re/importar los resultados de la carrera?" 
			],
			title: "Importar resultados",
			btnAccept: "IMPORTAR",
			classes: "modal-primary"
		}/*Optional params here*/);
	}

	RemoveUser(user)
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/backend/champs/removeraceresult/" + this.categoryId + "/" + this.raceId + "/" + user.id)
			.then(response => {
				this.$state.go("champresultedit", { categoryId: this.categoryId, raceId: this.raceId}, { reload: true });
			});
		})({
			html: [
				"<strong>{{vm.title}}</strong>",
				"¿Seguro que deseas eliminar el resultado del piloto?" 
			],
			vm: {title: this.c.title}
		}/*Optional params here*/);
	}

	CheckPoints(val, user, index)
	{
		if (val == "") val = null;
		if (val !== null)
		{
			var i = parseInt(val, 10);
			if (val != i)
				return "El valor debe ser un número entero";
		}
		else
		{
			val = 0;
		}
		
		this.$http.post("/api/backend/champs/updateraceresult/" + this.categoryId + "/" + this.raceId + "/" + user.id + "/" + index + "/" + val);
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*
function CollectChampResultData(data)
{
	var ret = {};
	
	ret.title = data.title;
	
	ret.selectedcategories = [];
	for (var i = 0; i < data.categories.length; ++i)
	{
		if (data.categories[i].selected === true) ret.selectedcategories.push(data.categories[i].id);
	}
	
	ret.published = data.published || false;
	
	return ret;
}
*/



// WEBPACK FOOTER //
// ./client/app/backend/champs/champ_resultedit.controller.js